const stationId = new URL(location.href).searchParams.get('station_id') || 'qmusic_nl'

export default stationId
